export const environment = {
    production: true,
    //API_URL_Main: 'https://maxushrapi.maxus.co.in/',
    API_URL_Main: 'https://maxedge2.maxus.co.in/',
    API_URL_MainSecondary: 'https://maxedge2.maxus.co.in/',
    //API_URL: 'https://maxedge2.maxus.co.in/',
    API_URL: '',
    Version: '2.0.3',
    VersionExist: true,
    LastVersionCheck:''
};
